<template>
    <div class="table-custom">
        <div id="table-ranking" class="example-preview table-responsive">
            <div class="my-rank" style=" color: #503694">VỊ TRÍ CỦA BẠN</div>
            <table class="table table-vertical-center">
                <tbody>
                    <template v-if="myRanking">
                        <tr class="row_table">
                            <td style="width: 80px;">
                                <span class="breaking-text">{{ myRanking?.rankType }}</span>
                            </td>
                            <td style="width: 150px">
                                <span class="breaking-text">{{ myRanking?.userId }}</span>
                            </td>
                            <td style="width: 220px">
                                <span class="breaking-text">{{ myRanking?.name }}</span>
                            </td>
                            <td v-if="!isMobile" style="width: 250px"> {{ myRanking?.department }}</td>
                            <td style="width: 120px; text-align: end">
                                <span>{{ myRanking?.score }}</span>
                            </td>
                        </tr>
                    </template>
                    <tr v-else>
                        <td class="text-center text-white" :colspan="isMobile ? 4 : 5">Chưa có dữ liệu</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserPositionHighlight',
    props: {
        myRanking: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    data() {
        return {
            isMobile: window.innerWidth < 768,
        }
    },
}
</script>

<style>
.my-rank {
    margin-top: 16px;
    background: linear-gradient(90deg, #fbc02d, #ffa000);
    border-radius: 9999px;
    padding: 4px;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
}
.row_table {
    border: none !important;
    color: white;
}
.table-custom{
    padding: 0 80px;
}
#table-ranking table tr td{
    border: none !important;
}
#table-ranking .example-preview{
    background: linear-gradient(to bottom, #AFA4F7, #503694);
}
@media only screen and (max-width: 1024px) {
    .table-custom{
        padding: 0 20px !important;
    }
}
</style>
